"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var currencies_1 = require("../../currencies");
var logic_1 = require("./logic");
var api_1 = require("./api");
var preload_1 = require("./preload");
var errors_2 = require("./errors");
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, estimatedFees, maxAmount, maxAmountWithFees, spendableBalanceWithFees, stakingThreshold, totalSpent, amount, isStakeAndNotEnoughBalance, isUnstakeOrWithdrawAndNotEnoughBalance, currency, formattedStakingThreshold;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(t.mode === "send")) return [3 /*break*/, 2];
                return [4 /*yield*/, getSendTransactionStatus(a, t)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                errors = {};
                warnings = {};
                useAllAmount = !!t.useAllAmount;
                if (!t.fees) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
                maxAmount = (0, logic_1.getMaxAmount)(a, t, estimatedFees);
                maxAmountWithFees = (0, logic_1.getMaxAmount)(a, t);
                spendableBalanceWithFees = (0, logic_1.getMaxAmount)(a, __assign(__assign({}, t), { mode: "stake" }));
                stakingThreshold = (0, logic_1.getYoctoThreshold)();
                totalSpent = (0, logic_1.getTotalSpent)(a, t, estimatedFees);
                amount = useAllAmount ? maxAmount : new bignumber_js_1.BigNumber(t.amount);
                isStakeAndNotEnoughBalance = t.mode === "stake" &&
                    (totalSpent.gt(maxAmountWithFees) || maxAmountWithFees.lt(estimatedFees));
                isUnstakeOrWithdrawAndNotEnoughBalance = ["unstake", "withdraw"].includes(t.mode) &&
                    (totalSpent.gt(spendableBalanceWithFees) ||
                        spendableBalanceWithFees.lt(estimatedFees));
                if (isStakeAndNotEnoughBalance || isUnstakeOrWithdrawAndNotEnoughBalance) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                else if (["stake", "unstake", "withdraw"].includes(t.mode) &&
                    amount.lt(stakingThreshold)) {
                    currency = (0, currencies_1.getCryptoCurrencyById)("near");
                    formattedStakingThreshold = (0, currencies_1.formatCurrencyUnit)(currency.units[0], stakingThreshold.plus(logic_1.YOCTO_THRESHOLD_VARIATION), {
                        showCode: true
                    });
                    errors.amount = new errors_2.NearStakingThresholdNotMet(undefined, {
                        threshold: formattedStakingThreshold
                    });
                }
                else if (t.mode === "unstake" && amount.gt(maxAmount)) {
                    errors.amount = new errors_2.NearNotEnoughStaked();
                }
                else if (t.mode === "withdraw" && amount.gt(maxAmount)) {
                    errors.amount = new errors_2.NearNotEnoughAvailable();
                }
                else if (amount.lte(0) && !t.useAllAmount) {
                    errors.amount = new errors_1.AmountRequired();
                }
                if (t.mode === "stake" && !errors.amount && t.useAllAmount) {
                    warnings.amount = new errors_2.NearUseAllAmountStakeWarning();
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
var getSendTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, storageCost, newAccountStorageCost, currency, formattedNewAccountStorageCost, recipientIsNewAccount, accountDetails, estimatedFees, totalSpent, maxAmount, maxAmountWithFees, amount;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errors = {};
                warnings = {};
                useAllAmount = !!t.useAllAmount;
                storageCost = (0, preload_1.getCurrentNearPreloadData)().storageCost;
                newAccountStorageCost = storageCost.multipliedBy(logic_1.NEW_ACCOUNT_SIZE);
                currency = (0, currencies_1.getCryptoCurrencyById)("near");
                formattedNewAccountStorageCost = (0, currencies_1.formatCurrencyUnit)(currency.units[0], newAccountStorageCost, {
                    showCode: true
                });
                if (!!t.recipient) return [3 /*break*/, 1];
                errors.recipient = new errors_1.RecipientRequired();
                return [3 /*break*/, 4];
            case 1:
                if (!!(0, logic_1.isValidAddress)(t.recipient)) return [3 /*break*/, 2];
                errors.recipient = new errors_1.InvalidAddress();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (0, api_1.fetchAccountDetails)(t.recipient)];
            case 3:
                accountDetails = _b.sent();
                if (!accountDetails) {
                    recipientIsNewAccount = true;
                    if ((0, logic_1.isImplicitAccount)(t.recipient)) {
                        warnings.recipient = new errors_2.NearNewAccountWarning(undefined, {
                            formattedNewAccountStorageCost: formattedNewAccountStorageCost
                        });
                    }
                    else {
                        errors.recipient = new errors_2.NearNewNamedAccountError();
                    }
                }
                _b.label = 4;
            case 4:
                if (a.freshAddress === t.recipient) {
                    warnings.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                }
                if (!t.fees) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
                totalSpent = (0, logic_1.getTotalSpent)(a, t, estimatedFees);
                maxAmount = (0, logic_1.getMaxAmount)(a, t, estimatedFees);
                maxAmountWithFees = (0, logic_1.getMaxAmount)(a, t);
                amount = useAllAmount ? maxAmount : new bignumber_js_1.BigNumber(t.amount);
                if (totalSpent.gt(maxAmountWithFees) || maxAmountWithFees.lt(estimatedFees)) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                else if (amount.lte(0) && !t.useAllAmount) {
                    errors.amount = new errors_1.AmountRequired();
                }
                else if (recipientIsNewAccount && amount.lt(newAccountStorageCost)) {
                    errors.amount = new errors_2.NearActivationFeeNotCovered(undefined, {
                        formattedNewAccountStorageCost: formattedNewAccountStorageCost
                    });
                }
                if (((_a = a.nearResources) === null || _a === void 0 ? void 0 : _a.stakingPositions) &&
                    a.nearResources.stakingPositions.length > 0 &&
                    useAllAmount) {
                    warnings.amount = new errors_2.NearRecommendUnstake();
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map